import React, { Component } from 'react';
import { config } from '../Constants';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import {Helmet} from "react-helmet";
import '../css/registermgm.css';


//import 'https://www.pf.co.th/dist/v2/app.css?t=1637921558';
//import 'https://www.pf.co.th/dist/projects/group.css?t=1637921558';

export default class RegisterMGM extends Component {

    constructor(props) {
        super(props);
        const params = new URLSearchParams(this.props.location.search);

        this.state = {
            project_home: [],
            gen_code: params.get('code')? params.get('code') : '',
            member_id: params.get('member_id')? params.get('member_id') : '',
            add_name: '',
            add_phone: '',
            add_email: '',
            add_project: '',
            registerIsOpen: false,
            successIsOpen: false,
            errorIsOpen: false,
        }

        this.clearData = this.clearData.bind(this);
        this.submitRegister = this.submitRegister.bind(this);
        this.closeRegister = this.closeRegister.bind(this);
        this.openRegister = this.openRegister.bind(this);
        this.change = this.change.bind(this);
        this.closeSuccess = this.closeSuccess.bind(this);
        this.openSuccess = this.openSuccess.bind(this);
        this.project_home = this.project_home.bind(this);
        
        this.closeError = this.closeError.bind(this);
        this.openError = this.openError.bind(this);

        this.project_home();
    }

    project_home() {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };

        fetch(config.url.API_URL + '/project_homes/', requestOptions)
                .then(res => res.json())
                .then(data => {

                    var FromApi = data.data.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '0', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });

    }

    clearData(e) {

            this.setState({ 
                add_name: '',
                add_phone: '',
                add_email: '',
                add_project: '',
                member_id: '',
                gen_code: ''
            });
    }

    submitRegister(e){
        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: this.state.add_name,
                phone: this.state.add_phone,
                email: this.state.add_email,
                project_home_id: this.state.add_project,
                gen_code: this.state.gen_code,
                member_id: this.state.member_id,
            }),
        };

        fetch(config.url.API_URL + '/registermgm', requestOptions)
            .then(res => res.json())
            .then(data => {
                //console.log(data)
                if(data.status == "Error"){
                    this.setState({
                        registerIsOpen: false,
                        error: data.message,
                        errorIsOpen: true,
                    });
                }else{
                    this.setState({
                        registerIsOpen: false,
                        successIsOpen: true,
                    });
                    this.clearData();
                }

            });
    }

    openRegister(e){

        if(this.state.gen_code == ""){
            alert("ไม่พบข้อมูล MGM Code");
            return;
        }

        if(this.state.member_id == ""){
            alert("ไม่พบข้อมูล Member ID");
            return;
        }

        if(this.state.add_name == ""){
            alert("ไม่พบข้อมูลชื่อ-นามสกุล");
            return;
        }

        if(this.state.add_email == ""){
            alert("ไม่พบข้อมูลอีเมล์");
            return;
        }

        if(this.state.add_phone == ""){
            alert("ไม่พบข้อมูลเบอร์โทรศัพท์");
            return;
        }

        if(this.state.add_project == ""){
            alert("ไม่พบข้อมูลโครงการบ้าน");
            return;
        }
        
        this.setState({ 
            registerIsOpen: true,
        });
    }

    closeRegister(e){

        document.getElementById("add_name").value = ""
        document.getElementById("add_phone").value = ""
        document.getElementById("add_email").value = ""
        document.getElementById("add_project").value = "0"
        this.setState({ 
            registerIsOpen: false,
            add_name: '',
            add_phone: '',
            add_email: '',
            add_project: '',
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    
    closeSuccess(e){
        this.setState({
            successIsOpen: false,
        });
    }

    openSuccess(e){
        this.setState({ 
            successIsOpen: true,
        });
    }
    
    closeError(e){
        this.setState({
            errorIsOpen: false,
        });
    }

    openError(e){
        this.setState({ 
            errorIsOpen: true,
        });
    }

    render() {
        return (<div>
                {/* <nav className="hero-nav">
                    <div className="nav nav-group">
                    <div className="nav-item">
                        <a href="#" className="item single-house active" data-label="บ้านเดี่ยว">
                        <p className="type-en">single-house</p>
                        <span className="type-th">บ้านเดี่ยว</span>
                        </a>
                    </div>
                    <div className="nav-item">
                        <a href="#" className="item townhome" data-label="ทาวน์โฮม">
                        <p className="type-en">townhome</p>
                        <span className="type-th">ทาวน์โฮม</span>
                        </a>
                    </div>
                    <div className="nav-item">
                        <a href="#" className="item condominium" data-label="คอนโดมิเนียม">
                        <p className="type-en">condominium</p>
                        <span className="type-th">คอนโดมิเนียม</span>
                        </a>
                    </div>
                    <div className="nav-item">
                        <a href="#" className="item resort-residence" data-label="รีสอร์ท เรสซิเดนซ์">
                        <p className="type-en">resort-residence</p>
                        <span className="type-th">รีสอร์ท เรสซิเดนซ์</span>
                        </a>
                    </div>
                    </div>
                    <div className="brand-list nav-brand">
                    <div className="brand-list-item nav-sub-location">
                        <a href="#lake-legend" className="nav-brand" title="เลค เลเจนด์" data-label="บ้านเดี่ยว_เลค เลเจนด์">
                        เลค เลเจนด์
                        </a>
                        <a href="#perfect-masterpiece-the-signature" className="nav-brand" title="เพอร์เฟค มาสเตอร์พีซ (The Signature)" data-label="บ้านเดี่ยว_เพอร์เฟค มาสเตอร์พีซ (The Signature)">
                        เพอร์เฟค มาสเตอร์พีซ (The Signature)
                        </a>
                        <a href="#perfect-masterpiece" className="nav-brand" title="เพอร์เฟค มาสเตอร์พีซ" data-label="บ้านเดี่ยว_เพอร์เฟค มาสเตอร์พีซ">
                        เพอร์เฟค มาสเตอร์พีซ
                        </a>
                        <a href="#perfect-residence" className="nav-brand" title="เพอร์เฟค เรสซิเดนซ์" data-label="บ้านเดี่ยว_เพอร์เฟค เรสซิเดนซ์">
                        เพอร์เฟค เรสซิเดนซ์
                        </a>
                        <a href="#perfect-place" className="nav-brand" title="เพอร์เฟค เพลส" data-label="บ้านเดี่ยว_เพอร์เฟค เพลส">
                        เพอร์เฟค เพลส
                        </a>
                        <a href="#perfect-park" className="nav-brand" title="เพอร์เฟค พาร์ค" data-label="บ้านเดี่ยว_เพอร์เฟค พาร์ค">
                        เพอร์เฟค พาร์ค
                        </a>
                        <a href="#lake-forest" className="nav-brand" title="เลค ฟอเรสต์" data-label="บ้านเดี่ยว_เลค ฟอเรสต์">
                        เลค ฟอเรสต์
                        </a>
                        <a href="#modi-villa" className="nav-brand" title="โมดิ วิลล่า" data-label="บ้านเดี่ยว_โมดิ วิลล่า">
                        โมดิ วิลล่า
                        </a>
                    </div>
                    </div>
                </nav> */}
                <div id="accordionLocationMap">
                    {/* <section className="brand lake-legend" id="lake-legend">
                    <div className="container-fluid">
                        <div className="row">
                        <div className="brand-info">
                            <div className="brand-info-image">
                            <img className="logo" src="https://asset.pf.co.th/project-brand/logo/572caafca4b52d1f.png" alt="เลค เลเจนด์" />
                            </div>
                            <div className="brand-info-name-price">
                            <h2 className="brand-info-name">เลค เลเจนด์</h2>
                            <p className="brand-info-price">
                                ราคา
                                <span className="huge">
                                26 - 70
                                </span>
                                ล้านบาท
                            </p>
                            <p className="brand-info-price">
                                ทั้งหมด
                                <span className="huge">2</span>
                                โครงการ
                            </p>
                            </div>
                            <p className="brand-content">
                            สัมผัสประสบการณ์ชีวิตสุดหรูติดทะเลสาบรูปแบบใหม่ โดดเด่นเหนือใคร เพียงแห่งเดียวในบรรยากาศสุดคลาสสิค ท่ามกลางสายน้ำ
                            </p>
                            <p className="open-map-lg">
                            <button className="d-inline-flex align-items-center justify-content-center justify-content-lg-start btn-open-map" data-target="#map-single-house-lake-legend" data-toggle="collapse" aria-expanded="false" aria-controls="map-single-house-lake-legend" data-label="เลค เลเจนด์_ดูแผนที่ีรวมทุกโครงการ">
                                <i className="pf-icon pf-icon-location mr-1" style={{color: '#523209'}} />
                                <span className="underline">ดูแผนที่ตั้งโครงการทั้งหมด</span>
                            </button>
                            </p>
                        </div>
                        <div className="project-list">
                            <div className="swiper-container project-list-carousel">
                            <div className="swiper-wrapper swiper-wrapper-custom">
                                <div className="swiper-slide" style={{ marginRight:"15px"}}>
                                <a href="/th/project/single-house/lake-legend/chaengwatthana" className="card card-location" data-label="เลค เลเจนด์_เลค เลเจนด์ แจ้งวัฒนะ">
                                    <img src="https://asset.pf.co.th/progressive/project-location/thumbnail/2b52eab57eeb7778.jpg" data-src="https://asset.pf.co.th/project-location/thumbnail/2b52eab57eeb7778.jpg" alt className="lazyload hero-image" />
                                    <div className="card-body">
                                    <h5 className="card-body-title">
                                        แจ้งวัฒนะ
                                    </h5>
                                    <ul className="card-list mb-0">
                                        <li className="card-list-item">
                                        <i className="pf-icon pf-icon-price" />
                                        <span>
                                            ราคา
                                            <span className="huge">
                                            26 - 70
                                            </span>
                                            ล้านบาท
                                        </span>
                                        </li>
                                        <li className="card-list-item">
                                        <i className="pf-icon pf-icon-information" />
                                        <span>เพียง 5 นาทีสู่ถนนแจ้งวัฒนะ สะดวกด้วยทางด่วน และรถไฟฟ้าสายสีชมพู</span>
                                        </li>
                                    </ul>
                                    </div>
                                </a>
                                </div>
                                <div className="swiper-slide">
                                <a href="/th/project/single-house/lake-legend/bangna-suvarnabhumi" className="card card-location" data-label="เลค เลเจนด์_เลค เลเจนด์ บางนา-สุวรรณภูมิ">
                                    <img src="https://asset.pf.co.th/progressive/project-location/thumbnail/6501a5b81e52199f.jpg" data-src="https://asset.pf.co.th/project-location/thumbnail/6501a5b81e52199f.jpg" alt className="lazyload hero-image" />
                                    <div className="card-body">
                                    <h5 className="card-body-title">
                                        บางนา – สุวรรณภูมิ
                                    </h5>
                                    <ul className="card-list mb-0">
                                        <li className="card-list-item">
                                        <i className="pf-icon pf-icon-price" />
                                        <span>
                                            เริ่มต้น
                                            <span className="huge">
                                            95
                                            </span>
                                            ล้านบาท
                                        </span>
                                        </li>
                                        <li className="card-list-item">
                                        <i className="pf-icon pf-icon-information" />
                                        <span>ใกล้สนามบินสุวรรณภูมิ และ Mega &amp; Ikea บางนา</span>
                                        </li>
                                    </ul>
                                    </div>
                                </a>
                                </div>
                            </div>
                            <div className="swiper-button-prev" />
                            <div className="swiper-button-next" />
                            </div>
                        </div>
                        <p className="open-map-md">
                            <button className="d-inline-flex align-items-center justify-content-center justify-content-lg-start" data-target="#map-single-house-lake-legend" data-toggle="collapse" aria-expanded="false" aria-controls="map-lake-legend">
                            <i className="pf-icon pf-icon-location mr-1" style={{color: '#523209'}} />
                            <span className="underline">ดูแผนที่ตั้งโครงการทั้งหมด</span>
                            </button>
                        </p>
                        </div>
                    </div>
                    </section>
                    <section className="location-map">
                    <div className="collapse" id="map-single-house-lake-legend" data-parent="#accordionLocationMap">
                        <div className="google-map-box">
                        <div id="google-map-single-house-lake-legend" className="maps google-map" />
                        </div>
                        <div className="coordinates">
                        <div className="coordinate" id="location-single-house-lake-legend-chaengwatthana" data-latitude="13.937671" data-longitude="100.488709" data-group="single-house" data-location-id={121}>
                        </div>
                        <div className="coordinate" id="location-single-house-lake-legend-bangna-suvarnabhumi" data-latitude data-longitude data-group="single-house" data-location-id={131}>
                        </div>
                        </div>
                    </div>
                    </section> */}

                    {/* OUR */}
                    <section>
                    <div className="ms-col-12 text-center">
                        <img src="../dist/img/log_NDV.png" alt="Nirvana Logo" class="brand-image" width="300px" height="auto" style={{paddingTop:"5%",paddingBottom:"2%"}}></img>
                    </div>
                        { this.state.successIsOpen == true ? 
                    <div className="txt-center mg">
                        <h3 className="brand-info-name">คุณได้ลงทะเบียนสำเร็จเรียบร้อยแล้ว</h3>
                    </div>
                    :   
                    <div>  
                    <div className="ms-col-12 text-center mg">
                        <h3 className="brand-info-name">คุณได้รับการแนะนำเพื่อน โครงการ Property Perfect โดย
                        <br className="br-none" />รหัสแนะนำ {this.state.gen_code}
                        <br />ถ้าหากสนใจเข้าชมโครงการกรุณาลงทะเบียนเพื่อเยี่ยมชมโครงการ
                        </h3>
                    </div>
                    <div className="card-detail">
                        <div className="grid-detail">
                        <div className="ms-col-1">
                            <h4 className="mb0">ชื่อ-สกุล :</h4>
                        </div>
                        <div className="ms-col-2">
                            <input type="text" className="input-detail" name='add_name' id="add_name" onChange={this.change}/>
                        </div>
                        </div>
                        <div className="grid-detail mt1">
                        <div className="ms-col-1">
                            <h4 className="mb0">เบอร์โทรศัพท์ :</h4>
                        </div>
                        <div className="ms-col-2">
                            <input type="text" className="input-detail" name='add_phone' id="add_phone" onChange={this.change}/>
                        </div>
                        </div>
                        <div className="grid-detail mt1">
                        <div className="ms-col-1">
                            <h4 className="mb0">อีเมล์ :</h4>
                        </div>
                        <div className="ms-col-2">
                            <input type="email" className="input-detail" name='add_email' id="add_email" onChange={this.change}/>
                        </div>
                        </div>
                        <div className="grid-detail mt1">
                        <div className="ms-col-1">
                            <h4 className="mb0">โครงการที่สนใจ :</h4>
                        </div>
                        <div className="ms-col-2">
                            <select className="select input-detail pd" name="add_project" id="add_project" onChange={this.change} style={{fontSize:'20px'}}>
                                {
                                    this.state.project_home.map((datas) =>
                                    <option value={datas.value}>{datas.display}</option>)
                                }
                            </select>
                        </div>
                        </div>
                        <div className="grid-detail mt1">
                        <div className="ms-col-1" />
                        <div className="ms-col-2 txt-center-mb">
                            <button className="btn-cf" onClick={this.openRegister}>ยืนยัน</button>
                        </div>
                        </div>
                    </div>
                    </div> 
    }
                    </section>
                </div>
    <Modal show={this.state.registerIsOpen} onHide={this.closeRegister} size="s">
        <ModalHeader>
        <ModalTitle>แจ้งเตือน</ModalTitle>
        </ModalHeader>
        <ModalBody>คุณต้องการยืนยันการลงทะเบียนครั้งนี้ใช่หรือไม่</ModalBody>
        <ModalFooter>
            <button className="btn btn-danger" onClick={this.closeRegister}>ยกเลิก</button>&nbsp;&nbsp;
            <button className="btn btn-success" onClick={this.submitRegister}>ยืนยัน</button>
        </ModalFooter>
    </Modal>

    <Modal show={this.state.errorIsOpen} onHide={this.closeError} size="s">
        <ModalHeader className="btn-danger" >
        <ModalTitle>แจ้งเตือน</ModalTitle>
        </ModalHeader>
        <ModalBody>เกิดข้อผิดพลาดในการลงทะเบียน {this.state.error}</ModalBody>
        <ModalFooter>
            <button className="btn btn-danger" onClick={this.closeError}>OK</button>
        </ModalFooter>
    </Modal>
    <Modal show={this.state.successIsOpen} onHide={this.closeSuccess} size="s">
        <ModalHeader>
        <ModalTitle>แจ้งเตือน</ModalTitle>
        </ModalHeader>
        <ModalBody>คุณได้ลงทะเบียนสำเร็จเรียบร้อยแล้ว</ModalBody>
        <ModalFooter>
            <button className="btn btn-success" onClick={this.closeSuccess}>OK</button>
        </ModalFooter>
    </Modal>
  <Helmet>
    <script type="text/javascript" src="https://www.pf.co.th/dist/v2/app.js?t=1637921558"></script>
    <script type="text/javascript" src="https://www.pf.co.th/dist/projects/group.js?t=1637921558"></script>
</Helmet>
</div>
)
    }
}